import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import appDataService from "../../../services/appData";


export const sendAppFeedBack = createAsyncThunk<any, any>(
  "appFeedback/sendAppFeedback",
  async (feedback, thunkAPI) => {
    try {
      return await appDataService.sendAppFeedback(feedback);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);
const initialState = {
  isLoading: false,
  isError: false,
  feedbackMessage: "",
};
const appFeedbackReducer = createSlice({
  name: "appFeedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendAppFeedBack.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(sendAppFeedBack.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.feedbackMessage = action.payload;
      })
      .addCase(sendAppFeedBack.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});
export default appFeedbackReducer.reducer;
